import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from "@angular/common";
import { Route, RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { changePasswordComponent } from "./change-password.component";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatButtonModule } from '@angular/material/button';
import { FuseAlertModule } from '@fuse/components/alert';


const ChangePasswordRoutes: Route[] = [
  {
    path: "",
    component: changePasswordComponent,
  },
];

@NgModule({
  declarations: [changePasswordComponent],
  imports: [
    RouterModule.forChild(ChangePasswordRoutes),
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    FuseAlertModule,
  ],
})
export class ChangePasswordModule { }

